export default __webpack_public_path__ + "static/media/inopticlas.6b4fc5fa.svg";